import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  loading: boolean;
  success: boolean;
  error: string | null;
  showLoader: boolean;
}

const initialState: AppState = {
  loading: false,
  success: false,
  error: null,
  showLoader: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setShowLoader: (state, action: PayloadAction<boolean>) => {
      state.showLoader = action.payload;
    },
  },
});

export const { setLoading, setSuccess, setError, setShowLoader } = appSlice.actions;

export default appSlice.reducer;
